export type DateTimeFormatConfig = { alternative?: string } & {
  default: string;
};

// Drawer row on selection (exotic / quaddie / single / same-event multi).
export const SELECTION_DATETIME: DateTimeFormatConfig = {
  alternative: "MMM do, yyyy @ HH:mm",
  default: "do MMM, yy @ HH:mm",
};

// Historic / settled list rows (pickem pick, promotion claims).
export const HISTORICAL_DATETIME: DateTimeFormatConfig = {
  alternative: "MMM do, yyyy @ HH:mm:ss",
  default: "do MMM, yy @ HH:mm:ss",
};

// Preference pages — cooldown / deposit-limit increase applied.
export const PREFERENCE_DATETIME: DateTimeFormatConfig = {
  alternative: "h:mm a, MMMM d",
  default: "h:mm a, d MMMM",
};

// Wallet statement rows (desktop table, pending withdrawals) with TZ.
export const STATEMENT_DATETIME_WITH_TZ: DateTimeFormatConfig = {
  alternative: "MMM d, yyyy @ HH:mm:ss z",
  default: "do MMM, yy @ HH:mm:ss z",
};

// Mobile wallet statement — shorter variant with TZ.
export const STATEMENT_DATETIME_SHORT_WITH_TZ: DateTimeFormatConfig = {
  alternative: "MM/dd/yy @ HH:mm z",
  default: "dd/MM/yy @ HH:mm z",
};

// Event countdown tooltip.
export const EVENT_START_DATETIME: DateTimeFormatConfig = {
  alternative: "MMM dd, yyyy '@' h:mma",
  default: "dd MMM yy '@' h:mma",
};

// Bet entry clamp — date without year.
export const BET_ENTRY_DATETIME: DateTimeFormatConfig = {
  alternative: "MMM do @ HH:mm",
  default: "do MMM @ HH:mm",
};

// Match header status pill on mobile — compact, month name keeps it unambiguous in every region.
export const MATCH_HEADER_DATETIME_SHORT: DateTimeFormatConfig = {
  default: "MMM d @ HH:mm",
};

// Quaddie picks drawer — shares shape with SELECTION_DATETIME but uses two-digit year.
export const QUADDIE_PICKS_DATETIME: DateTimeFormatConfig = {
  alternative: "MMM d, yyyy @ HH:mm",
  default: "do MMM, yy @ HH:mm",
};

// Activity-statement numeric row date.
export const ACTIVITY_STATEMENT_DATETIME: DateTimeFormatConfig = {
  alternative: "MM/dd/yyyy HH:mm:ss",
  default: "dd/MM/yyyy HH:mm:ss",
};

// Help-centre download filename timestamp.
export const HELP_CENTER_EXPORT_DATETIME: DateTimeFormatConfig = {
  alternative: "MM/dd/yyyy, h:mmaaa",
  default: "dd/MM/yyyy, h:mmaaa",
};

// Race competitor scratched-at timestamp.
export const COMPETITOR_SCRATCHED_DATETIME: DateTimeFormatConfig = {
  alternative: "LL/dd, hh:mm aaa",
  default: "dd/LL, hh:mm aaa",
};

// Self-exclusion narrative sentence ("until 6:00 pm on Thursday, 3 April 2026").
export const SELF_EXCLUDED_DATETIME: DateTimeFormatConfig = {
  alternative: "h:mm aaa 'on' EEEE, MMMM d, yyyy",
  default: "h:mm aaa 'on' EEEE, d MMMM yyyy",
};

// Date-only, numeric, short (match page header).
export const NUMERIC_DATE_SHORT: DateTimeFormatConfig = {
  alternative: "MM/dd/yy",
  default: "dd/MM/yy",
};

// Locale-native short date+time ('p, P' tokens resolve from date-fns locale).
export const LOCALE_NATIVE_DATETIME: DateTimeFormatConfig = { default: "p, P" };

// Locale-native long date (date picker).
export const LOCALE_NATIVE_LONG_DATE: DateTimeFormatConfig = { default: "PPP" };

export const USER_DOB: DateTimeFormatConfig = {
  alternative: "MM/dd/yyyy",
  default: "dd/MM/yyyy",
};
